import React from "react";

import type {
  Paging,
  ProcedureTag,
} from "../../../../application/domain/proc-management";
import { useModal } from "../../../../utils/custom-hooks";
import Title from "../../../atoms/proc-management/title";
import {
  MainMenu,
  ProcTagCreateModal,
  ProcTagsTable,
} from "../../../molecules/proc-management/procedure-tag-list";
import { useAuthContextV2 } from "../../../../auth-state";
import { Redirect } from "react-router-dom";
import { TtzkPortalR } from "../../../pages/ttzk-portal/route";

type Props = {
  procTags: ProcedureTag[];
  orgId: string;
  orgSlug: string;
  paging: Paging;
  onCreate: (
    organizationId: string,
    name: string,
    priority: number,
    suppressOnPortal: boolean,
    pageNum: number,
  ) => void;
  onDelete: (organizationId: string, tagId: string, pageNum: number) => void;
  onUpdate: (
    id: string,
    organizationId: string,
    name: string,
    priority: number,
    suppressOnPortal: boolean,
    pageNum: number,
  ) => void;
  onPageClick: (props: { orgId: string; page: number }) => void;
};

export const Content: React.FC<Props> = ({
  procTags,
  orgId,
  orgSlug,
  paging,
  onCreate,
  onDelete,
  onUpdate,
  onPageClick,
}) => {
  const { auth } = useAuthContextV2();
  const createModal = useModal();

  if (!auth.isPortalStandardPlan()) {
    return <Redirect to={TtzkPortalR.Home.link({})} />;
  }

  return (
    <>
      <Title text="手続きタグ一覧" />
      <div className="notification">
        <p className="content">
          <h3 className={"title is-5"}>手続きタグの設定について</h3>
          <ul>
            <li>
              手続きタグを作成し、手続きマスタにタグの紐付けを行うことで、Grafferポータルにおいてタグでの絞り込みを行うことができます。
            </li>
            <li>
              また、Grafferポータルを利用している場合にタグの一覧がトップページに表示されます。
            </li>
            <li>表示順は数値の小さい順に表示されます。</li>
            <li>
              トップページへの手続きタグの表示上限はありませんが、表示するタグが多すぎると読みにくくなりますので、下記のトップページ掲載の設定を使ってトップページに掲載するタグは取捨選択することをおすすめします。
            </li>
            <li>
              トップページ掲載の設定を「掲載しない」に設定すると、タグがトップページに表示されなくなります。
              ただし、当該設定を行っても、手続きマスタの詳細ページや検索画面等ではタグが表示されます。
              またトップページ掲載をしないタグも絞り込み検索で利用することができます。
            </li>
          </ul>
        </p>
      </div>
      <hr className="my-3" />
      <MainMenu onStartCreation={createModal.open} />
      <ProcTagsTable
        procTags={procTags}
        orgId={orgId}
        orgSlug={orgSlug}
        paging={paging}
        onPageClick={onPageClick}
        onDelete={(tagId: string, pageNum: number) =>
          onDelete(orgId, tagId, pageNum)
        }
        onUpdate={onUpdate}
      />
      <ProcTagCreateModal
        isActive={createModal.isActive}
        onClose={createModal.close}
        onCreate={(
          name: string,
          priority: number,
          suppressOnPortal: boolean,
          pageNum: number,
        ) => {
          onCreate(orgId, name, priority, suppressOnPortal, pageNum);
          createModal.close();
        }}
        pageNum={paging.current}
      />
    </>
  );
};

export default Content;
